import {
  NOTI_PRIORITY_LOW,
  NOTI_PRIORITY_HIGH,
  NOTI_PRIORITY_URGENT,
  NOTI_PRIORITY_EMERGENCY,
} from 'app/constants/priority'

export const mapPriority = (id) => {
  switch (id) {
    case NOTI_PRIORITY_LOW.id:
      return NOTI_PRIORITY_LOW.label
    case NOTI_PRIORITY_HIGH.id:
      return NOTI_PRIORITY_HIGH.label
    case NOTI_PRIORITY_URGENT.id:
      return NOTI_PRIORITY_URGENT.label
    case NOTI_PRIORITY_EMERGENCY.id:
      return NOTI_PRIORITY_EMERGENCY.label
    default:
      return
  }
}
